<template>
  <BQdtCard
    name="balanceHelp"
    type="help"
  />
</template>

<script>
import { BQdtCard } from '@/components/blocks'

export default {
  name: 'BalanceHelp',

  components: { BQdtCard },
}
</script>
